import { createContext, useState, useContext, useEffect } from "react";

import { api } from "../../services/api";

export const DrinksContext = createContext([]);

export const DrinksProvider = ({ children }) => {
  const [drinks, setDrinks] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isClose, setIsClose] = useState(true);
  const [page, setPage] = useState(25);

  const nextPage = () => {
    page < 75 && setPage(page + 25);
  };

  const previousPage = () => {
    page > 25 && setPage(page - 25);
  };

  const localHousing = () =>
    localStorage.setItem("drinks", JSON.stringify(drinks));

  const drinksList = (data) => {
    api
      .get(`/beers?page=2&per_page=${page}`, data)
      .then((response) => {
        setDrinks(response.data);
        localHousing();
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    localHousing();
    drinksList();
  }, [page]);

  return (
    <DrinksContext.Provider
      value={{
        drinks,
        setDrinks,
        isOpen,
        setIsOpen,
        isClose,
        setIsClose,
        nextPage,
        previousPage,
      }}
    >
      {children}
    </DrinksContext.Provider>
  );
};

export const useDrinks = () => useContext(DrinksContext);
